import React from 'react';
import styled from 'styled-components';

const TabsContainer = styled.div`
  display: flex;
  border-bottom: 2px solid #E8ECF0;
  margin-bottom: 20px;
  gap: 4px;
`;

const Tab = styled.button`
  padding: 10px 20px;
  border: none;
  background: none;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  color: ${({ $active, theme }) => ($active ? theme.colors.primary.main : theme.colors.text.dark.little)};
  border-bottom: 2px solid ${({ $active, theme }) => ($active ? theme.colors.primary.main : 'transparent')};
  margin-bottom: -2px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export default function Tabs({ tabs, activeTab, onChange }) {
  return (
    <TabsContainer>
      {tabs.map((tab) => (
        <Tab key={tab.key} $active={activeTab === tab.key} onClick={() => onChange(tab.key)}>
          {tab.label}
        </Tab>
      ))}
    </TabsContainer>
  );
}
